import { createRuntimeGoogleState } from '../init/ga/state';
import { checkGaInit } from '../init/ga';
import {
  trackConfirmation,
  trackECommerceData,
  trackECommerceUserProperties,
} from './tracking';
import { handleProducts } from './products';
import { ECommerce4Transaction, TrackECommerceArg } from './types';
import { checkECommerceDataError } from './error';
import { trackTMSConfirmation } from './tmsConfirmation';
import { getEcommerceData } from './utils';
/**
 * This function is responsible for tracking eCommerce data. It initializes necessary repositories and clients,
 * checks Google Analytics initialization, sets parameters, and tracks user properties. It also handles products
 * if they exist in the eCommerce data.
 *
 * @async
 * @function
 * @param {TrackECommerceArg | ECommerce4Transaction} eCommerceData - The eCommerce data to be tracked. This can be of type TrackECommerceArg or ECommerce4Transaction. Defaults to an empty object.
 * @returns {Promise<void>} Returns a promise that resolves when all tracking and handling operations are complete.
 */
export const trackECommerce = async (
  eCommerceData: TrackECommerceArg | ECommerce4Transaction
): Promise<void> => {
  if (checkECommerceDataError(eCommerceData)) {
    return;
  }
  await checkGaInit();
  const { setParameters } = createRuntimeGoogleState();
  setParameters({ hasThePageBeenTracked: false });
  trackECommerceUserProperties(eCommerceData);
  trackECommerceData(eCommerceData);
  await handleProducts(eCommerceData);
  await trackConfirmation();
  trackTMSConfirmation(
    getEcommerceData(eCommerceData)?.ga4Data?.transaction_id || '',
    getEcommerceData(eCommerceData)?.ga4Data?.value || ''
  );
};
